import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import ConsultanciesList from "./ConsultanciesList";

const ConsultanciesListWrapper = () => {

    const { userCan, isFacilitatorManager } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Asesorías', href: menuRoutes.consultancies.path },
    ];

    const defaultFilters = {
        active: true,
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de asesorías" breadcrumb={breadCrumb}>
                    {
                        !isFacilitatorManager &&
                        userCan('create_consultancies', 'consultancies') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { navigate(menuRoutes.consultancies.create) }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear asesoría
                            </Button>
                        )
                    }

                </PageHeader>
                <ConsultanciesList />
            </FiltersProvider>
        </Fragment>
    );
}

export default ConsultanciesListWrapper;
